import { TriggerParams } from '@/models/TriggerParams';

import { BuildConfigurationType } from '../types';
import getBuildParams from './getBuildParams';

const CLI_PARAMS: ReadonlySet<string> = new Set<keyof TriggerParams>([
  'branch',
  'commitHash',
  'commitMessage',
  'environments',
  'licensePoolId',
  'machineTypeId',
  'pipelineId',
  'priority',
  'stack',
  'tag',
  'workflowId',
]);

const toLabel = (param: string) => param.replace(/[A-Z]/g, (letter) => ` ${letter.toLowerCase()}`);

const getUnsupportedCliParams = (data: BuildConfigurationType): string[] =>
  Object.keys(getBuildParams(data))
    .filter((param) => !CLI_PARAMS.has(param))
    .map(toLabel);

export default getUnsupportedCliParams;
